/**
 * @file paddle Wave Summit 2020 活动卡片
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, { useMemo } from 'react';
import { Modelprops } from './type';
import './style.less'

const ActiveList: React.FC<Modelprops> = (props) => {
    const list = useMemo(() => {
        return props.list || [];
    }, [props.list]);




    return (
        <div className="paddlenlp-model">

            <div className="model-card-wrapper">
                {
                    list.map(item =>
                        <div className="paddlenlp-model-all">

                            <div className="paddlenlp-model-content">
                                <p className="model-title-h">{item.title}</p>
                                <p className="model-title-t">{item.text}</p>

                            </div>
                        </div>

                    )
                }

            </div>

        </div>
    );
};

export default ActiveList;
